import React from 'react';
import { SearchIcon } from 'lucide-react';
interface ProjectFiltersProps {
  searchQuery: string;
  setSearchQuery: (q: string) => void;
  sectorFilter: string;
  setSectorFilter: (s: string) => void;
  statusFilter: string;
  setStatusFilter: (s: string) => void;
  sectors: string[];
}
export function ProjectFilters({
  searchQuery,
  setSearchQuery,
  sectorFilter,
  setSectorFilter,
  statusFilter,
  setStatusFilter,
  sectors
}: ProjectFiltersProps) {
  return <div className="bg-white rounded-lg border border-gray-border p-6 mb-8" data-id="element-376" data-mp="28v34j8glrjkb">
      <div className="grid md:grid-cols-3 gap-4" data-id="element-377" data-mp="2dt4nzuhxxkwb">
        <div data-id="element-378" data-mp="1zslhirt4imw9">
          <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-379" data-mp="1zt3oaidewjif">
            Search
          </label>
          <div className="relative" data-id="element-380" data-mp="24ry5xgzn820y">
            <SearchIcon size={20} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-381" data-mp="24szsahm40axz" />
            <input type="text" placeholder="Search projects..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-border rounded-lg focus:outline-none focus:ring-2 focus:ring-au-green" data-id="element-382" data-mp="301vkap7oy7r" />
          </div>
        </div>

        <div data-id="element-383" data-mp="21l46eivrs5fe">
          <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-384" data-mp="21klzmsbhe8t8">
            Sector
          </label>
          <select value={sectorFilter} onChange={e => setSectorFilter(e.target.value)} className="w-full px-4 py-2 border border-gray-border rounded-lg focus:outline-none focus:ring-2 focus:ring-au-green" data-id="element-385" data-mp="1durp4hemwwc5">
            <option value="All Sectors" data-id="element-386" data-mp="1nrctr1mqs5fg">All Sectors</option>
            {sectors.map(s => <option key={s} value={s} data-id="element-387" data-mp="1iwz4lgyoauj8">
                {s}
              </option>)}
          </select>
        </div>

        <div data-id="element-388" data-mp="2uaazv3gda4ts">
          <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-389" data-mp="2uakvb6k6l46v">
            Status
          </label>
          <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="w-full px-4 py-2 border border-gray-border rounded-lg focus:outline-none focus:ring-2 focus:ring-au-green" data-id="element-390" data-mp="329pfhazf1kxi">
            <option value="all" data-id="element-391" data-mp="3ga8oolfmax19">All Status</option>
            <option value="active" data-id="element-392" data-mp="3g9qgcqfokscz">Active</option>
            <option value="completed" data-id="element-393" data-mp="2imrrv2z56qq6">Completed</option>
          </select>
        </div>
      </div>
    </div>;
}